import React, { useState } from "react";
import "./Login.css";
import { Link, useHistory } from "react-router-dom";
import { auth } from "./Firebase";

const Login = () => {
	const history = useHistory();
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");

	const signInHandler = (e) => {
		e.preventDefault();
		if (
			!email.includes("@") ||
			!email.slice(email.indexOf("@")).includes(".") ||
			email.slice(email.indexOf("@")).length < 4 ||
			email.slice(0, email.indexOf("@")).length < 4 ||
			password.length < 6
		)
			return;
		auth
			.signInWithEmailAndPassword(email, password)
			.then((auth) => {
				if (auth) {
					history.push("/");
				}
			})
			.catch((err) => alert(err.message));
	};
	const registerAccountHandler = (e) => {
		e.preventDefault();
		if (!email.includes("@") || password.length < 6) return;
		if (
			!email.includes("@") ||
			!email.slice(email.indexOf("@")).includes(".") ||
			email.slice(email.indexOf("@")).length < 4 ||
			password.length < 6
		)
			return;
		auth
			.createUserWithEmailAndPassword(email, password)
			.then((auth) => {
				if (auth) {
					history.push("/");
				}
			})
			.catch((err) => alert(err.message));
	};

	return (
		<div className="login">
			<Link to="/">
				<img
					className="login__logo"
					src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Amazon_logo.svg/1000px-Amazon_logo.svg.png"
					alt="logo"
				/>
			</Link>
			<div className="login__container">
				<h1>Sign In</h1>
				<form>
					<h5>Email</h5>
					<input
						type="text"
						value={email}
						onChange={(e) => setEmail(e.target.value)}
					/>
					<h5>Password</h5>
					<input
						type="password"
						value={password}
						onChange={(e) => setPassword(e.target.value)}
					/>
					<p>Passwords must be at least 6 characters.</p>
					<button onClick={signInHandler} className=" login__signInButton">
						Sign In
					</button>
				</form>
				<p>
					Please read the conditions carefully before using the Amazon Shop Stop
					website.
				</p>
				<button
					onClick={registerAccountHandler}
					className="login__registerButton"
				>
					Create your Account
				</button>
			</div>
		</div>
	);
};

export default Login;
